import BaseComponent from "@js/components/base_component.jsx";
import classNames from "@js/helpers/class_names.js";

class MuiAlertCriteria extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      criteria_type: props.entity.criteria_type,
      destroyed: props.entity.destroyed,
    };
  }

  render() {
    const name = (field) => (
      `mui_alert[alert_criterias_attributes][${ this.props.index }][${ field }]`
    );

    return (
      <div>
        <input
          type="hidden"
          name={ name("id") }
          value={ this.props.entity.id }
        />

        {
          this.state.destroyed ? (

            <input
              type="hidden"
              name={ name("_destroy") }
              value={ "1" }
            />

          ) : (

            <div>

              <div className={ classNames({ "col-sm-12": true }) }>

                <SelectField
                  field="mui_alert_criteria.criteria_type"
                  blank="mui_alert_criteria_criteria_type"
                  name={ name("criteria_type") }
                  value={ this.props.entity.criteria_type }
                  options={ this._criteriaTypeOptions() }
                  editing={ this.props.editing }
                  error={ this.props.entity.errors ? this.props.entity.errors.criteria_type : null }
                  onChange={ (e) => this.setState({ criteria_type: e.target.value }) }
                  valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                >
                  {
                    this.props.editing && (
                      <div className="col-sm-1 text-right">
                        <ButtonWithIcon
                          type="danger"
                          icon="remove"
                          onClick={ () => this.setState({ destroyed: true }) }
                          tabIndex="-1"
                          tooltip="mui_alert_criteria__remove_criteria"
                        />
                      </div>
                    )
                  }
                </SelectField>

                {
                  ( this.state.criteria_type == "pct_inbox" || this.state.criteria_type == "pct_bulk" || this.state.criteria_type == "pct_missing" ) && (
                    <SelectField
                      field="mui_alert_criteria.pct_operator"
                      blank="select_an_operator"
                      name={ name("pct_operator") }
                      value={ this.props.entity.pct_operator }
                      options={ this._pctOperatorOptions() }
                      editing={ this.props.editing }
                      error={ this.props.entity.errors ? this.props.entity.errors.pct_operator : null }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                      onChange={ () => {} }
                    />
                  )
                }

                {
                  ( this.state.criteria_type == "pct_inbox" || this.state.criteria_type == "pct_bulk" || this.state.criteria_type == "pct_missing" ) && (
                    <InputField
                      object={ this.props.entity }
                      type="mui_alert_criteria"
                      field="pct_value"
                      name={ name("pct_value") }
                      editing={ this.props.editing }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  ( this.state.criteria_type == "isp" || this.state.criteria_type == "isp_group" ) && (
                    <SelectField
                      field="mui_alert_criteria.isp_operator"
                      blank="select_an_operator"
                      name={ name("isp_operator") }
                      value={ this.props.entity.isp_operator || "is" }
                      options={ this._ispOperatorOptions() }
                      editing={ this.props.editing }
                      error={ this.props.entity.errors ? this.props.entity.errors.isp_operator : null }
                      onChange={ () => {} }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  this.state.criteria_type == "isp" && (
                    <SelectField
                      field="mui_alert_criteria.isp_list"
                      name={ name("isp_list_array") + "[]" }
                      value={ this.props.entity.isp_list }
                      optionsGrouped={ this.props.isp_options }
                      editing={ this.props.editing }
                      error={ this.props.entity.errors ? this.props.entity.errors.isp_list : null }
                      onChange={ () => {} }
                      multiple={ true }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  this.state.criteria_type == "isp_group" && (
                    <SelectField
                      field="mui_alert_criteria.isp_list"
                      name={ name("isp_list_array") + "[]" }
                      value={ this.props.entity.isp_list }
                      options={ this.props.isp_group_options }
                      editing={ this.props.editing }
                      error={ this.props.entity.errors ? this.props.entity.errors.isp_list : null }
                      onChange={ () => {} }
                      multiple={ true }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  ( this.state.criteria_type == "from_address" ) && (
                    <SelectField
                      field="mui_alert_criteria.from_operator"
                      blank="select_an_operator"
                      name={ name("from_operator") }
                      value={ this.props.entity.from_operator }
                      options={ this._fromOperatorOptions() }
                      editing={ this.props.editing }
                      error={ this.props.entity.errors ? this.props.entity.errors.from_operator : null }
                      onChange={ () => {} }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  ( this.state.criteria_type == "from_address" ) && (
                    <InputField
                      object={ this.props.entity }
                      type="mui_alert_criteria"
                      field="from_value"
                      name={ name("from_value") }
                      editing={ this.props.editing }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  ( this.state.criteria_type == "subject" ) && (
                    <SelectField
                      field="mui_alert_criteria.subject_operator"
                      blank="select_an_operator"
                      name={ name("subject_operator") }
                      value={ this.props.entity.subject_operator }
                      options={ this._subjectOperatorOptions() }
                      editing={ this.props.editing }
                      error={ this.props.entity.errors ? this.props.entity.errors.subject_operator : null }
                      onChange={ () => {} }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

                {
                  ( this.state.criteria_type == "subject" ) && (
                    <InputField
                      object={ this.props.entity }
                      type="mui_alert_criteria"
                      field="subject_value"
                      name={ name("subject_value") }
                      editing={ this.props.editing }
                      valueColumnClass={ this.props.editing ? "col-sm-7" : "col-sm-8" }
                    />
                  )
                }

              </div>

              {
                ( this.props.editing || !this.props.is_last_criteria ) && (
                  <div className="col-sm-12">
                    <hr/>
                  </div>
                )
              }

            </div>

          )
        }
      </div>
    );
  }

  _criteriaTypeOptions() {
    return [
      { "value": "pct_inbox",    "label": "% Inbox"      },
      { "value": "pct_bulk",     "label": "% Bulk"       },
      { "value": "pct_missing",  "label": "% Missing"    },
      { "value": "isp",          "label": "ISP"          },
      { "value": "isp_group",    "label": "ISP Group"    },
      { "value": "from_address", "label": "From Address" },
      { "value": "subject",      "label": "Subject"      },
    ];
  }

  _ispOperatorOptions() {
    return [
      { "value": "is",               "label": "is"               },
      { "value": "is_not",           "label": "is not"           },
    ];
  }

  _pctOperatorOptions() {
    return [
      { "value": "greater_than",    "label": "Greater Than"    },
      { "value": "less_than",       "label": "Less Than"       },
    ];
  }

  _fromOperatorOptions() {
    return [
      { "value": "is",               "label": "is"               },
      { "value": "is_not",           "label": "is not"           },
      { "value": "contains",         "label": "contains"         },
      { "value": "does_not_contain", "label": "does not contain" },
    ];
  }

  _subjectOperatorOptions() {
    return this._fromOperatorOptions();
  }

}

export default MuiAlertCriteria;
